<template>
	<div class="LanguageSelect">
		<Dropdown v-bind:options="dropdownOptions" v-bind:initialValue="value"
			v-on:input="value = $event">
		</Dropdown>
	</div>
</template>

<script>
import { getLanguageIds, langId, setLang } from '../lang'

import Dropdown from './Dropdown'

export default {
	name: 'LanguageSelect',
	props: {},
	data: () => ({
		value: langId,
		dropdownOptions: getLanguageIds().map(langId => {
			return {
				key: langId,
				name: langId.toUpperCase()
			}
		})
	}),
	mounted: function() {
		window.envPromise.then(env => {
			this.dropdownOptions = this.dropdownOptions.filter(options => {
				return env.SUPPORTED_LANGUAGES.includes(options.key)
			})
			if (!env.SUPPORTED_LANGUAGES.includes(this.value)) {
				this.value = 'en'
			}
		})
	},
	watch: {
		value(newValue) {
			setLang(newValue)
			location.reload()
		},
	},
	methods: {},
	components: {
		Dropdown
	},
	beforeMount() {},
}
</script>

<style lang="stylus" scoped>
.LanguageSelect {
	height: 60px;
	position: relative;
	color: white;
	font-weight: bold;

	& > .Dropdown {
		position: absolute;
		top: 50%;
		right: 0;
		transform: translateY(-50%);
	}
}

</style>
